import { ProductPermissions } from '../constants/constants';

export interface Error {
  code: string;
  message: string;
}

export interface APIError {
  traceId: string;
  requestId: string;
  errors: Error[];
}

export interface User {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly route: string;
  readonly permissions: ProductPermissions[];
}

export interface Action<T1 = any, T2 = any> {
  type: T1;
  payload?: T2;
}

export interface CustomerLocationState {
  customer: any;
  customerIndex: number;
}

export const EVENT_TYPES: Record<string, string> = {
  SE: 'Store Event',
  D: 'Delivery',
  CO: 'Carry Out',
  CI: 'CarryIn',
  S: 'Service',
  SCI: 'Service Carry In',
  SCO: 'Service Carry Out',
  STOPIC: 'Store Pick-up',
  FIELD: 'Field Visit',
  P: 'Pickup',
  G: 'General',
  SO: 'Switchout',
  SP: 'Service Pickup',
  TR: 'Transfer',
  TRD: 'Transfer Delivery',
  TRP: 'Transfer Pickup',
  AD: 'Acima Delivery',
};
export function getEventType(refCode: string): string | undefined {
  return EVENT_TYPES[refCode];
}
